import { useEffect, useState } from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";
import { api, fmtBtc } from "@/lib/api";
import { PageHeader, StatCard, StatusBadge, Empty } from "@/components/shared";

export default function AdminOverview() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, []);
  return (
    <div>
      <PageHeader title="Statistiques globales" subtitle="Toutes plateformes, tous modes confondus." />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        <StatCard label="Marchands" value={s?.merchants ?? "—"} hint={s ? `${s.active_merchants} actifs` : ""} testId="admin-stat-merchants" />
        <StatCard label="Commandes" value={s?.total_orders ?? "—"} hint={s ? `${s.live_orders} en live` : ""} testId="admin-stat-orders" />
        <StatCard label="Volume confirmé" value={s ? fmtBtc(s.volume_btc) : "—"} testId="admin-stat-volume" accent="text-amber-400" />
        <StatCard label="Webhooks" value={s ? `${s.pending_webhooks} en file` : "—"} hint={s ? `${s.failed_webhooks} en échec` : ""} testId="admin-stat-webhooks" accent={s?.failed_webhooks ? "text-red-400" : ""} />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-6">
        <div className="panel p-5 lg:col-span-2">
          <div className="eyebrow mb-4">Commandes par jour</div>
          {s?.daily_orders?.length ? (
            <ResponsiveContainer width="100%" height={220}>
              <BarChart data={s.daily_orders}><CartesianGrid stroke="#27272A" vertical={false} /><XAxis dataKey="date" tick={{ fill: "#71717A", fontSize: 11 }} tickFormatter={(d) => d.slice(5)} /><YAxis tick={{ fill: "#71717A", fontSize: 11 }} width={30} allowDecimals={false} /><Tooltip contentStyle={{ background: "#121215", border: "1px solid #27272A", borderRadius: 8, fontSize: 12 }} /><Bar dataKey="count" fill="#F7931A" radius={[4, 4, 0, 0]} /></BarChart>
            </ResponsiveContainer>
          ) : <Empty text="Aucune commande." />}
        </div>
        <div className="panel p-5"><div className="eyebrow mb-4">Répartition par statut</div>
          <div className="space-y-2">{s && Object.entries(s.by_status).map(([k, v]) => <div key={k} className="flex justify-between items-center text-sm"><StatusBadge status={k} /><span className="font-mono">{v}</span></div>)}{s && !Object.keys(s.by_status).length && <Empty text="—" />}</div>
        </div>
      </div>
    </div>
  );
}
